import React from 'react';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const CustomCheckBox = ({ item }) => {
  let today = new Date().toISOString();

  let dayLeft = new Date(item.endDate) - new Date(today);
  //   console.log('dayLeft', dayLeft, item.className);
  return (
    <div>
      {item.className !== 'Nursery' &&
      item.className !== 'KG' &&
      item.className !== 'Senior KG' ? (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={dayLeft < 0 || item.status === false ? false : true}
              disabled={
                item.endDate === null || item.status === false
                  ? true
                  : dayLeft > 0
                  ? false
                  : true
              }
            />
          }
          label={`Class ${item.className}`}
        />
      ) : (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={dayLeft < 0 || item.status === false ? false : true}
              disabled={
                item.endDate === null || item.status === false
                  ? true
                  : dayLeft > 0
                  ? false
                  : true
              }
            />
          }
          label={item.className}
        />
      )}
    </div>
  );
};

export default CustomCheckBox;
